'use client';

import * as React from 'react';
import { WidgetId } from '@/edge/constants';
import { useEdgeConfigWidget } from '@/shared/modules/edge-config';
import { CopiedIcon } from './copied-icon';
import * as Styled from './copy-button.styled';
import { CopyIcon } from './copy-icon';
interface CopyButtonProps {
  clipboardText?: string;
}
export const CopyButton = React.memo(function CopyButton({
  clipboardText
}: CopyButtonProps) {
  const {
    strings
  } = useEdgeConfigWidget(WidgetId.CopyableText);
  const [isCopied, setIsCopied] = React.useState(false);
  const textToCopy = clipboardText || strings.clipboardText;
  const onButtonClick = React.useCallback(() => {
    if (!isCopied) {
      navigator.clipboard.writeText(textToCopy);
      setIsCopied(true);
    }
  }, [textToCopy, isCopied]);
  return <Styled.CopyButton type="button" onClick={onButtonClick} $isCopied={isCopied} color="primary" icon={isCopied ? CopiedIcon : CopyIcon}>
      {isCopied ? strings.copiedButtonText : strings.copyButtonText}
    </Styled.CopyButton>;
});